import React from "react";
import "./UnAuthorizedAccess.css";
import svg from "../../assets/unauthorized.svg";

const UnAuthorizedAccess = () => {
  return (
    <div className="unauth-wrapper">
      <div className="unauth-container">
        <div className="unauth-grid">
          {/* Image Column */}
          <div className="unauth-col unauth-image">
            <img src={svg} alt="Unauthorized" className="unauth-svg" />
          </div>

          {/* Text Column */}
          <div className="unauth-col unauth-text">
            <h1 className="unauth-title">Unauthorised Access</h1>

            <p className="unauth-sub">
              If you need access to the Cambridge OCR Moderation Service,
              please contact your exams officer.
            </p>

            <p className="unauth-sub">
              If you know you already have access to this service,
              please contact Cambridge OCR at&nbsp;
              <br />
              
              <a
                href="mailto:support@ocr.org.uk"
                className="unauth-link"
              >
                support@ocr.org.uk
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnAuthorizedAccess;
